import DataTable from "react-data-table-component"

const InvoiceId = () => {
  const data = [
    {
      orderId: "346345",
      noOfProducts: 1,
      provider: "Delivery: Mae-go",
      trackingId: "Mae-go3446477",
      invoiceId: "345345",
    },
  ]

  const columns = [
    { name: "Order ID", selector: (row) => row.orderId },
    { name: "No. of Products", selector: (row) => row.noOfProducts },
    { name: "Provider", selector: (row) => row.provider },
    { name: "Tracking ID", selector: (row) => row.trackingId },
    { name: "Invoice ID", selector: (row) => row.invoiceId },
  ]

  const customStyles = {
    table: {
      style: {
        border: "1px solid #D9D9D9",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#F2F2F2",
      },
    },
  }

  return (
    <div>
      <DataTable data={data} columns={columns} customStyles={customStyles} />
    </div>
  )
}

export default InvoiceId
